import { SET_COOKIES_MODAL } from '../../constants/actions';

export function setCookiesModal(data) {
  return (dispatch) => dispatch({ type: SET_COOKIES_MODAL, data });
}



// WEBPACK FOOTER //
// ./src/store/actions/cookiesModal.js